var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "485 3033 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ef806f;\n      }\n\n      .cls-2 {\n        fill: #edc92c;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning",
    transform: "translate(485 3033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    className: "cls-1",
    d: "M50,0A50,50,0,1,1,0,50,50,50,0,0,1,50,0Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_384",
    "data-name": "Path 384",
    className: "cls-2",
    d: "M137.194,123.269,102.888,67.977a2.191,2.191,0,0,0-3.724,0l-34.4,55.444a2.191,2.191,0,0,0,1.862,3.347h68.811a2.19,2.19,0,0,0,1.757-3.5Z",
    transform: "translate(-50.839 -52.816)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M222.415,170.988l-.711-10.643q-.2-3.111-.2-4.466a4.051,4.051,0,0,1,.966-2.877,3.317,3.317,0,0,1,2.545-1.034,2.56,2.56,0,0,1,2.556,1.322,8.962,8.962,0,0,1,.644,3.81,29.347,29.347,0,0,1-.155,2.977l-.956,10.955a8.562,8.562,0,0,1-.667,3,1.747,1.747,0,0,1-1.689,1.043,1.677,1.677,0,0,1-1.666-1.01A10,10,0,0,1,222.415,170.988Zm2.466,14.62a3.493,3.493,0,0,1-2.366-.876,3.075,3.075,0,0,1-1.01-2.455,3.3,3.3,0,0,1,3.333-3.312,3.289,3.289,0,0,1,2.388.966,3.159,3.159,0,0,1,.989,2.346,3.1,3.1,0,0,1-1,2.444A3.4,3.4,0,0,1,224.882,185.609Z",
    transform: "translate(-174.767 -119.903)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.02dfc29caef5bdb438606cb8972d714d.svg";
export { ForwardRef as ReactComponent };